"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropertyDefinition = exports.isOneToManyRelationshipField = exports.isOneToOneRelationshipField = exports.isRelationshipField = exports.getAggregateDataFields = void 0;
const getAggregateDataFields = (aggregateDefinition, aggregateDefinitions, isChild, otherAttributes, includeOneToMany, useView) => {
    if (aggregateDefinition) {
        const definitions = useView && aggregateDefinition.view ? aggregateDefinition.view : aggregateDefinition.propertyDefinitions;
        const assetsScalarFields = definitions
            .filter(column => !otherAttributes ? !column.isRelationship : !column.isRelationship && otherAttributes.includes(column.field))
            .map(columnDef => {
            if (columnDef.type === 'Geography' || columnDef.type === 'AnchoredLine') {
                return `${columnDef.field} { geojson }`;
            }
            return columnDef.field;
        })
            .join(' ');
        const assetsRelationshipFields = definitions
            .filter(column => (!otherAttributes
            ? column.isRelationship
            : column.isRelationship && otherAttributes.includes(column.field)) &&
            (column.relationshipType === 'ONE_TO_ONE' || includeOneToMany))
            .map(columnDef => {
            var _a;
            let relationColumns = '{id label}';
            if (aggregateDefinitions && !isChild) {
                const aggrDef = aggregateDefinitions.find(aggrDef => aggrDef.name === columnDef.type);
                const cardDefinition = aggrDef === null || aggrDef === void 0 ? void 0 : aggrDef.cardDefinition;
                const otherAttributeItemKeys = (_a = cardDefinition === null || cardDefinition === void 0 ? void 0 : cardDefinition.otherAttributes) === null || _a === void 0 ? void 0 : _a.map(otherAttribute => otherAttribute.itemKey);
                if ((cardDefinition === null || cardDefinition === void 0 ? void 0 : cardDefinition.pageName) || (otherAttributeItemKeys && otherAttributeItemKeys.length > 0)) {
                    if (cardDefinition === null || cardDefinition === void 0 ? void 0 : cardDefinition.pageName) {
                        relationColumns = `{id label ${(0, exports.getAggregateDataFields)(aggrDef, aggregateDefinitions, true)}}`;
                    }
                    else {
                        relationColumns = `{id label ${getSymbolKey(aggrDef, otherAttributeItemKeys)} ${(0, exports.getAggregateDataFields)(aggrDef, aggregateDefinitions, true, otherAttributeItemKeys)}}`;
                    }
                }
            }
            return (`${columnDef.field} ${relationColumns}` +
                (columnDef.relationshipType === 'ONE_TO_ONE' ? ` ${columnDef.field}Id` : ''));
        })
            .join(' ');
        return `
    ${assetsScalarFields}
    ${!definitions.find(x => x.field === 'modifiedBy') && !!definitions.find(x => x.field === 'createdBy')
            ? 'modifiedBy: createdBy'
            : ''}
    ${assetsRelationshipFields}`;
    }
    return '';
};
exports.getAggregateDataFields = getAggregateDataFields;
const getSymbolKey = (aggrDef, otherAttributeItemKeys) => {
    const SYMBOL_KEY = 'symbolKey';
    const properties = (aggrDef === null || aggrDef === void 0 ? void 0 : aggrDef.propertyDefinitions.map(propertyDefinition => propertyDefinition.field)) || [];
    if (properties.includes(SYMBOL_KEY) && !(otherAttributeItemKeys || []).includes(SYMBOL_KEY)) {
        return SYMBOL_KEY;
    }
    return '';
};
const isRelationshipField = (aggregateDefinitions, aggregateTypeName, fieldName) => {
    var _a;
    return (_a = (0, exports.getPropertyDefinition)(aggregateDefinitions, aggregateTypeName, fieldName)) === null || _a === void 0 ? void 0 : _a.isRelationship;
};
exports.isRelationshipField = isRelationshipField;
const isOneToOneRelationshipField = (aggregateDefinitions, aggregateTypeName, fieldName) => {
    var _a;
    const relationshipType = (_a = (0, exports.getPropertyDefinition)(aggregateDefinitions, aggregateTypeName, fieldName)) === null || _a === void 0 ? void 0 : _a.relationshipType;
    return relationshipType === 'ONE_TO_ONE' || relationshipType === 'ONE-TO-ONE';
};
exports.isOneToOneRelationshipField = isOneToOneRelationshipField;
const isOneToManyRelationshipField = (aggregateDefinitions, aggregateTypeName, fieldName) => {
    var _a;
    const relationShipType = (_a = (0, exports.getPropertyDefinition)(aggregateDefinitions, aggregateTypeName, fieldName)) === null || _a === void 0 ? void 0 : _a.relationshipType;
    return relationShipType === 'ONE_TO_MANY' || relationShipType === 'ONE-TO-MANY';
};
exports.isOneToManyRelationshipField = isOneToManyRelationshipField;
const getPropertyDefinition = (aggregateDefinitions, aggregateTypeName, fieldName) => {
    const aggregateDefinition = aggregateDefinitions.find(aggregateDefinition => aggregateDefinition.name === aggregateTypeName);
    return aggregateDefinition === null || aggregateDefinition === void 0 ? void 0 : aggregateDefinition.propertyDefinitions.find(propertyDefinition => propertyDefinition.field === fieldName);
};
exports.getPropertyDefinition = getPropertyDefinition;
//# sourceMappingURL=graphql.js.map